/*
 * Created by Anup Shrestha (anup.stha012@gmail.com)
 * Copyright (c) 2022.  All rights reserved.
 * Last modified 5/9/22, 7:45 AM
 *
 */

import { useEffect } from 'react';
import { Bars } from 'react-loader-spinner';
import { Outlet, useLocation } from 'react-router-dom';
import Cookies from 'js-cookie';
import { useAppDispatch, useAppSelector } from 'stores';

import { authService, setToken } from 'features/auth';

import Wrapper from 'components/layout/Wrapper';

const ProtectedRoute = ({ allowedRoles }: { allowedRoles: string[] }) => {
  /**
   * React Router Hook
   */

  /**
   * Redux Dispatch & Selectors
   */
  const dispatch = useAppDispatch();
  const auth = useAppSelector((state) => state.auth);
  const token = useAppSelector((state) => state.auth.token);
  const user = useAppSelector((state) => state.auth.user);

  /**
   * React Query
   */
  const { refetch, data } = authService.useProfile({ enabled: false });

  /**
   * Cookie
   */
  const cookieToken = Cookies.get('token');

  useEffect(() => {
    if (cookieToken) {
      if (!token) {
        dispatch(setToken(cookieToken));
      } else {
        refetch().then(() => {
          Cookies.remove('token');
          Cookies.remove('token', { domain: '.sunya.health', path: '/' });
        });
      }
    } else {
      if (!token) {
        const devEnv = process.env.REACT_APP_ENVIRONMENT === 'DEVELOPMENT';

        if (devEnv) {
          window.open('https://dev.app.sunya.health', '_self');
        } else {
          window.open('https://app.sunya.health', '_self');
        }
      } else {
        refetch();
      }
    }
  }, [cookieToken, token]);

  return !data && !user ? (
    <div>
      <div className="flex h-[100vh] items-center justify-center">
        <Bars color="green" />
      </div>
    </div>
  ) : auth?.role && allowedRoles.includes(auth.role) ? (
    <Wrapper>
      <Outlet />
    </Wrapper>
  ) : null;
};

export default ProtectedRoute;
